export const COLOR_SCHEMES = {
	blue: { bg: 'rgb(219 234 254)', text: 'rgb(30 64 175)' },
	orange: { bg: 'rgb(255 237 213)', text: 'rgb(154 52 18)' },
	pink: { bg: 'rgb(252 231 243)', text: 'rgb(157 23 77)' },
	gray: { bg: 'rgb(243 244 246)', text: 'rgb(31 41 55)' },
	purple: { bg: 'rgb(243 232 255)', text: 'rgb(107 33 168)' },
	red: { bg: 'rgb(254 226 226)', text: 'rgb(153 27 27)' },
	magenta: { bg: 'rgb(250 232 255)', text: 'rgb(134 25 143)' },
	lime: { bg: 'rgb(236 252 203)', text: 'rgb(63 98 18)' },
	amber: { bg: 'rgb(254 243 199)', text: 'rgb(146 64 14)' },
	teal: { bg: 'rgb(204 251 241)', text: 'rgb(17 94 89)' },
	rose: { bg: 'rgb(255 228 230)', text: 'rgb(159 18 57)' },
	green: { bg: 'rgb(209 250 229)', text: 'rgb(6 95 70)' },
	indigo: { bg: 'rgb(224 231 255)', text: 'rgb(55 48 163)' }
}

export const createCategoryColors = mapping =>
	Object.entries(mapping).reduce((acc, [color, categories]) => {
		categories.forEach(cat => (acc[cat] = COLOR_SCHEMES[color]))
		return acc
	}, {})

export const CATEGORY_COLORS = createCategoryColors({
	red: ['cardiovascular', 'circulatory', 'danger_signs'],
	rose: ['blood_diseases'],
	blue: ['respiratory', 'musculoskeletal'],
	indigo: ['nervous_system', 'genitourinary'],
	purple: ['infectious_parasitic'],
	magenta: ['mental_behavioural'],
	amber: ['digestive'],
	lime: ['endocrine_nutritional_metabolic'],
	teal: ['eye_adnexa'],
	orange: ['injury_poisoning_abuse', 'ear_and_mastoid'],
	green: ['immune'],
	pink: ['pregnancy_childbirth_perinatal_puerperium', 'skin_subcutaneous'],
	gray: ['other_illness']
})

export function getCategoryColors(categoryKey) {
	const normalizedKey = categoryKey
		? categoryKey.toLowerCase().trim()
		: ''
	return CATEGORY_COLORS[normalizedKey] || { bg: '#60A5FA', text: '#FFFFFF' }
}
